import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import { validString, validNumber, validBoolean } from "Components/shared/helpers/validations";

const coordinateObject = Yup.object().shape(
  reverseShape({
    lat: validString.required(),
    lon: validString.required(),
  }),
);

const Stations = Yup.object().shape(
  reverseShape({
    stationName: validString.required(),
    stationCode: validString.optional(),
    interStationETA_s: validNumber.required(),
    interStationDistance_m: validNumber.required(),
    interchangeable: validBoolean.required(),
    coordinate: coordinateObject.required(),
    trainLineIDs: Yup.array().min(0),
  }),
);
const stations = Yup.array().min(1).of(Stations);

export const LineSchema = Yup.object().shape(
  reverseShape({
    _id: validString.optional(),
    name: validString.required(),
    stations: stations.required(),
  }),
);
